import { render, staticRenderFns } from "./nav-link.vue?vue&type=template&id=2929a174&scoped=true&"
import script from "./nav-link.vue?vue&type=script&lang=ts&"
export * from "./nav-link.vue?vue&type=script&lang=ts&"
import style0 from "./nav-link.vue?vue&type=style&index=0&id=2929a174&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2929a174",
  null
  
)

export default component.exports